import { type CardholderConstructor } from '../../entities/Cardholder'
import { type CardholderApiModel } from '../api-models/CardholderApiModel'

export const mapCardholderApiModel = (
  data: CardholderApiModel
): CardholderConstructor => ({
  id: data.id,
  userId: data.user_id,
  email: data.email,
  firstName: data.first_name,
  lastName: data.last_name,
  profileImage: data.profile_image ?? '',
  externalId: data.external_id,
  tosAccepted: data.tos_accepted,
  secondaryCategoryId: data.department_id ?? null,
  provider: data.provider,
})
